import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { News } from '@model/webFeeder/news.model';
import { Constants } from '@utils/constants';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html'
})
export class NewsDetailComponent implements OnInit {

  @Input() data: { new: News, close: boolean, origin: string };
  @Output() closeDetail = new EventEmitter();
  public newWF: News = new News();
  public urlImg: string;
  public close: boolean;
  public origin: string;

  constructor() { }

  ngOnInit() {
    const d = document.createElement('div');
    this.close = this.data.close;
    this.origin = this.data.origin;
    this.newWF = this.data.new;
    d.innerHTML = this.newWF.description;
    const image = d.getElementsByTagName('img').item(0);
    if (image) {
      this.urlImg = image.getAttribute('src');
      document.getElementById('div-detail').style.height = '45vh';
    }
    this.newWF.img = this.newWF.agencyDescription ? Constants.NEWS_COMPANIES_URL.find(x => x.name.toLowerCase() === this.newWF.agencyDescription.toLowerCase()).url : null;
    setTimeout(() => {
      this.scrollTopInit();
    }, 500);
  }

  scrollTopInit() {
    const mainDiv = document.getElementById('scrollable-area');
    if (mainDiv && mainDiv.scrollTop && mainDiv.scrollTop > 0) {
      mainDiv.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  closeDetails() {
    this.closeDetail.emit(this.newWF);
  }

  scrollTop() {
    const mainDiv = document.getElementById('scrollable-area');
    mainDiv.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onScroll(event) {
    if (event.target.scrollTop > 0) {
      document.getElementById('btn-scroll').classList.remove('btn-hidden');
    } else {
      document.getElementById('btn-scroll').classList.add('btn-hidden');
    }
  }
}
